import {Component, Input, OnInit} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TableViewAbstractComponent} from '../../table-view-abstract/table-view-abstract.component';

@Component({
  selector: 'app-table-column-status',
  templateUrl: './table-column-status.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css']
})
export class TableColumnStatusComponent extends TableViewAbstractComponent implements OnInit {
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }
  ngOnInit() {
  }
  submitSet() {
    this.taskHttpService.doEditColumnHeader(this.groupData.boardId, this.columnData.id, this.columnData).subscribe((res: any) => {
      this.nzMessageService.create('success', '设置成功！');
    });
  }
}
